import * as ActionTypes from './actionTypes'

export const setDeviceType = (payload) => {
    return {
        type: ActionTypes.SET_DEVICE_TYPE,
        payload
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/mobile-device-detector/src/actions/actions.js